import { Popover, Transition } from '@headlessui/react';
import Carousel from 'nuka-carousel';
import useTranslation from '../../../../../hooks/useTranslations';
import useWindowWidth from '../../../../../hooks/useWindowWidth';
import { ArrowIcon, CloseIcon } from '../../../../misc/icons/Icons';
import ObjectTile from '../../partials/tiles/ObjectTile';

const FeaturedObjectsSlider = ({ featuredItems }) => {
	const t = useTranslation();
	// TODO: Geht das auch anders?
	const width = useWindowWidth();

	const slideNumber = () => {
		if (width >= 1536) {
			return 4;
		}
		if (width >= 1280) {
			return 3;
		}
		return 2;
	};

	return (
		<Popover>
			{({ open }) => (
				<div className={`transition duration-300 ease-out transform absolute left-0 bottom-14 z-30 hidden lg:flex items-start w-full ${open ? 'bg-oly-gray-lightestAlpha45' : 'pointer-events-none'}`}>
					<Popover.Button
						className={`flex text-left items-center justify-between p-2 min-w-62 w-62 group bg-oly-gray-lightestAlpha45 text-oly-gray-darkest focus:outline-none rounded-r-full mt-14 mr-16 mb-16 ${open ? 'pointer-events-none' : '!pointer-events-auto shadow-xl can-hover:hover:bg-oly-gray-lightest focus-visible:bg-oly-gray-lightest'}`}
					>
						{/* TODO: Get transKey from data (BA -> moreInfoBox -> translationkey) */}
						<span className={`${open ? 'text-[2.1875rem]' : 'text-[1.5625rem]'} ml-6`}>{t('dyn_nabo_more_information#')}</span>
						<ArrowIcon className={`w-7 h-7 transform rotate-180 mx-4 flex-shrink-0 ${open ? 'invisible' : ''}`} />
					</Popover.Button>
					<Transition
						enter="transition duration-300 ease-out transform"
						enterFrom="translate-y-full"
						enterTo="translate-y-0"
						leave="transition duration-300 ease-out transform"
						leaveFrom="translate-y-0 opacity-100"
						leaveTo="translate-y-full opacity-0"
						className="flex flex-grow"
					>
						<Popover.Panel className="flex flex-grow pl-78 -ml-78">
							<Carousel
								slidesToShow={slideNumber()}
								slidesToScroll={slideNumber()}
								framePadding="4rem"
								defaultControlsConfig={{
									pagingDotsClassName: 'focus:outline-none text-oly-gray-normal !fill-current',
								}}
								renderCenterLeftControls={({ previousSlide }) => (
									<button
										type="button"
										onClick={previousSlide}
										className="focus:outline-none"
										aria-labelledby="previous-slide"
									>
										<ArrowIcon className="w-12 h-12 transform rotate-90 text-oly-gray-normal" strokeWidth="1" />
									</button>
								)}
								renderCenterRightControls={({ nextSlide }) => (
									<button
										type="button"
										onClick={nextSlide}
										className="focus:outline-none"
										aria-labelledby="next-slide"
									>
										<ArrowIcon className="w-12 h-12 transform -rotate-90 text-oly-gray-normal" strokeWidth="1" />
									</button>
								)}
							>
								{featuredItems && featuredItems.map((object) => <ObjectTile key={object.id} object={object} isSliderTile />)}
							</Carousel>
						</Popover.Panel>
					</Transition>
					{open && (
						<Popover.Button className="absolute top-0 flex items-center p-3 right-2 focus:outline-none text-oly-blue-dark">
							<CloseIcon className="w-6 h-6" />
						</Popover.Button>
					)}
				</div>
			)}
		</Popover>
	);
};

export default FeaturedObjectsSlider;
